import { takeLatest, put, select } from 'redux-saga/effects';
import { matchPath } from 'react-router';

import { sagaErrorDispatcher } from 'Helpers';
import { userSelectors } from 'Ducks';
import generalActions from './actions';
import generalTypes from './types';
import routes from 'Pages/router/constants/routes';

function* initializeStart(action) {
	try {
		//do sth if you need login stuff
		const user = yield select(userSelectors.selectSession);
		onRedirectGuestUserToAuth(action.payload, user);

		yield put(generalActions.initializeFinished());
	} catch (e) {
		yield sagaErrorDispatcher(e, action, generalActions.initializeFinished);
	}
}

const onRedirectGuestUserToAuth = (payload = {}, user) => {
	const { navigate, pathname } = payload;
	if (navigate && pathname && matchPath) {
		const modifiedString = window.location.href.split('pwa')[1];
		if (
			modifiedString !== routes.login &&
			modifiedString !== routes.signup &&
			modifiedString !== routes.signupBusiness &&
			modifiedString !== routes.loginRedirect &&
			modifiedString !== routes.guest &&
			modifiedString !== routes.gtm &&
			modifiedString !== routes.offlineVendors
		)
			sessionStorage.setItem('redirect', modifiedString);
		if (modifiedString.includes(routes.offlineVendors)) return true;
		const validGuestUrls = [
			routes.guest,
			routes.gtm,
			routes.login,
			routes.signup
		];
		let isrouteValid = false;
		validGuestUrls.forEach((pattern) => {
			matchPath(pattern, pathname) && (isrouteValid = true);
		});
		if ((!user?.email || !user?.authentication_token) && !isrouteValid) {
			navigate(routes.login, { replace: true });
		}
	}
};

const generalSagas = [
	takeLatest(generalTypes.INITIALIZE.START, initializeStart)
];

export default generalSagas;
